<template lang="html">
<div>
      <div class="subpage delcare1">
            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                <div class="text-block title-block clearfix">
                    <div class="bName">标题</div>
                    <div class="bContent">
                        <el-form-item style="width:100%;" prop="title">
                           <el-input class="inpText" size="medium" v-model="params.title" placeholder="请输入内容"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="selects">

                        <div class="select-line">

                            <div class="selectGp">
                                    <span>政策分类</span>
                                    <el-form-item prop="declarationOrPolicyClassificationId">
                                        <dic-select code="sbhzcfl"
                                            :selectId="params.declarationOrPolicyClassificationId"
                                            paramsKey="declarationOrPolicyClassification"
                                            @selectChange="selectChange"
                                            plaText="政策分类" />
                                    </el-form-item>
                            </div>

                            <div class="selectGp">
                                    <span>特定对象</span>
                                    <el-form-item prop="specificObjectId">
                                        <all-select code="tddx"
                                            :selectId="params.specificObjectId"
                                            paramsKey="specificObject"
                                            @selectChange="allSelect"
                                            plaText="特定对象" />
                                    </el-form-item>
                            </div>

                            <div class="selectGp">
                                    <span>发布层级</span>
                                    <el-form-item prop="releaseLevelId">
                                        <dic-select code="fbjb" :selectId="params.releaseLevelId" paramsKey="releaseLevel" plaText="发布层级" @selectChange="selectChange" />
                                    </el-form-item>
                            </div>

                        </div>

                        <div class="select-line">

                            <div class="selectGp">
                                <span>发文机构</span>
                                <el-form-item prop="publishingDepartmentNames">
                                    <el-input v-model="params.publishingDepartmentNames" placeholder="如有多个机构，请用 ‘，’ 隔开" size="medium"></el-input>
                                </el-form-item>

                            </div>

                            <div class="selectGp">
                                <span>发文字号</span>
                                <el-input v-model="params.sendTextNumber" size="medium"></el-input>
                            </div>

                            <div class="selectGp">
                                <span>成文日期</span>
                                <el-form-item prop="writtenDate">
                                    <el-date-picker
                                    size="medium"
                                    align="right"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    v-model="params.writtenDate"
                                    placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>

                        </div>

                        <div class="select-line">

                            <div class="selectGp">
                                    <span>开始日期</span>
                                    <el-form-item prop="applicationStartDate">
                                        <el-date-picker
                                        size="medium"
                                        align="right"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        v-model="params.applicationStartDate"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                    </el-form-item>
                            </div>

                            <div class="selectGp">
                                    <span>截止日期</span>
                                    <el-form-item prop="applicationDeadline">
                                        <el-date-picker
                                        size="medium"
                                        align="right"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        v-model="params.applicationDeadline"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                    </el-form-item>
                            </div>

                            <div class="selectGp">
                                    <span>申报状态</span>
                                    <el-form-item prop="declarationStatusId">
                                        <dic-select code="sbzt" :selectId="params.declarationStatusId" paramsKey="declarationStatus" plaText="申报状态" @selectChange="selectChange" />
                                    </el-form-item>
                            </div>

                        </div>
                        <div class="text-block title-block clearfix">
                            <div class="bName">受理时间</div>
                            <div class="bContent">
                                <el-form-item style="width:100%;" prop="title">
                                    <el-time-picker
                                        v-model="applicationTime"
                                        align="right"
                                        size="medium"
                                        is-range
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        format="HH:mm"
                                        @change="pickerChange"
                                        value-format="HH:mm"
                                        placeholder="选择时间">
                                    </el-time-picker>
                                </el-form-item>
                            </div>
                        </div>
                        
                </div>
            </el-form>
            <div class="text-block img-block clearfix">
                <div class="bName">封面图</div>
                <div class="bContent">
                      <img-upload :image="params.image" @imgChange="imgChange" tips="（115*70推荐）" />
                </div>
            </div>

            <div class="enclosure">
                 <div class="ttl">附件</div>
                 <div class="ecContent">
                      <file-upload :files="params.fileId" @fileChange="fileChange" />
                 </div>
            </div>

            <div class="text-block tag-block clearfix">
                <div class="bName">标签</div>
                <div class="bContent">
                     <tag-select :selectTags="params.tagNames" paramsKey="tagNames" @selectChange="tagChange" />
                </div>
            </div>

            <div class="text-block radio-block clearfix">
                <div class="bName">可见范围</div>
                <div class="bContent">
                    <el-radio-group v-model="radioType">
                       <el-radio border size="medium" :label="1">全部</el-radio>
                       <el-radio border size="medium" :label="2">指定类型</el-radio>
                       <el-radio border size="medium" :label="3">指定企业</el-radio>
                       <el-radio border size="medium" :label="4">指定用户</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="text-block check-block clearfix">
                <div class="bName"></div>
                <div class="bContent">
                    <div v-if="radioType==2">
                        <el-checkbox-group v-model="idArr1">
                            <el-checkbox v-for="(item,index) in selectList1" :key="index" :label="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-if="radioType==3" class="check-seek">
                        <div class="seek-head">
                            <i class="el-icon-search"></i>
                            <el-select
                                filterable
                                remote
                                 @change="handleChange"
                                 :remote-method="entSeek"
                                 :loading="loading1"
                                 v-model="entId"
                                 placeholder="搜索企业名称">

                                <el-option
                                  v-for="item in selectList2"
                                  :key="item.id"
                                  :label="item.companyName"
                                  :value="item.id">
                                </el-option>

                            </el-select>

                            <el-button @click="entSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                        </div>
                        <div class="seek-body">
                            <el-tag
                              v-for="(item,index) in idArr2"
                              :key="index"
                              :value="item.id"
                              type="danger"
                              @close="entRemove(index)"
                              closable>
                              {{item.name}}
                            </el-tag>
                        </div>
                    </div>
                    <div v-if="radioType==4" class="check-seek">
                        <div class="seek-head">
                            <i class="el-icon-search"></i>
                            <el-select
                                 filterable
                                 remote
                                 :remote-method="userSeek"
                                 :loading="loading2"
                                 v-model="userId"
                                 placeholder="搜索用户">
                                <el-option
                                  v-for="item in selectList3"
                                  :key="item.userId"
                                  :label="item.name"
                                  :value="item.userId">
                                  <span>{{ item.name }}</span>
                                  <span>（{{ item.enterpriseName }}）</span>
                                </el-option>

                            </el-select>

                            <el-button @click="userSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                        </div>
                        <div class="seek-body">
                            <el-tag
                              v-for="(item,index) in idArr3"
                              :key="index"
                              type="danger"
                              @close="userRemove(index)"
                              closable>
                              {{item.name}}（{{item.enterpriseName}}）
                            </el-tag>
                        </div>
                    </div>
                </div>
            </div>


      </div>
</div>
</template>

<script>
import { decPredat } from "@/api/declare/declare";
import { dicSeek } from "@/api/pgMent/dictMent";
import { getEnterpriseList } from "@/api/attes/attestation";
import { getEntUser } from "@/api/enterprise/index";

export default {
    data(){
        return{

            idArr1:[],   // 指定类型
            idArr2:[],   // 指定企业
            idArr3:[],   // 指定用户

            radioType:1,

            entId:'',
            entMap:{},
            loading1:false,

            userId:'',
            userMap:{},
            loading2:false,

            selectList1:[],
            selectList2:[],
            selectList3:[],
            applicationTime:null,
            params:{

                title:'',
                declarationOrPolicyClassification:'',  // 政策分类
                declarationOrPolicyClassificationId:'',

                specificObject:'',  // 特定对象
                specificObjectId:'',

                releaseLevel:'',  // 发布级别
                releaseLevelId:'',

                publishingDepartmentIds:'',   // 发文机构
                publishingDepartmentNames:'',

                sendTextNumber:'',  //发文字号
                writtenDate:'', // 成文日期

                applicationStartDate:'',  // 开始日期
                applicationDeadline:'',  // 截止日期

                declarationStatus:'',  // 申报状态
                declarationStatusId:'',

                visibleRangeType:'',   // 可见范围指定类型
                visibleRangeUser:'',   // 可见范围指定用户
                visibleRangeEnterprise:'',   // 可见范围指定企业

                tagNames:'',

                image:'',  //  封面图
                fileId:'',  // 附件
                applicationTimeStart:'',
                applicationTimeEnd:'',

            },
            rules:{
                title:[{
                   required: true,
                   trigger: 'blur'
                }],
                declarationOrPolicyClassificationId:[{
                    required: true,
                    trigger: 'change'
                }],
                specificObjectId:[{
                    required: true,
                    trigger: 'change'
                }],
                releaseLevelId:[{
                    required: true,
                    trigger: 'change'
                }],
                industryId:[{
                    required: true,
                    trigger: 'change'
                }],
                publishingDepartmentNames:[{
                    required: true,
                    trigger: 'change'
                }],
                writtenDate:[{
                    required: true,
                    trigger: 'blur'
                }],
                applicationStartDate:[{
                    required: true,
                    trigger: 'change'
                }],
                applicationDeadline:[{
                    required: true,
                    trigger: 'change'
                }],
                declarationStatusId:[{
                    required: true,
                    trigger: 'change'
                }],
                tagNames:[{
                    required: true,
                    trigger: 'change'
                }],
            }
        }
    },
    methods:{
        selectChange:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },
        tagChange:function(e){
            this.params[e.paramsKey] = e.id;
        },
        allSelect:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },
        fileChange:function(e){    //  附件
            if(e.length > 0){
               this.params.fileId = JSON.stringify(e);
            }else{
               this.params.fileId = '';
            }
        },
        pickerChange:function(e){
            if(e){
                this.params.applicationTimeStart=e[0];
                this.params.applicationTimeEnd=e[1];
            }else{
                this.params.applicationTimeStart='';
                this.params.applicationTimeEnd='';
            }
            console.log(this.params);
        },
        imgChange:function(e){
            this.params.image = e;
        },
        inpChange:function(e){
            if(e === 1){
                this.$refs.showClose = true;
            }
        },

        entSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 statusList:[1,2,4],
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12
              }).then(res => {
                 vues.selectList2 = res.enterpriseList;
                 res.enterpriseList.forEach((item, i) => {
                     vues.entMap[item.id] = item;
                 });

              })
            }
        },

        entSelect:function(){
            let isSelected = false;
            this.idArr2.forEach((item, i) => {
                if(item.id == this.entId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                this.entMap[this.entId].name = this.entMap[this.entId].companyName;
                this.idArr2.push(this.entMap[this.entId]);
            }else{
                this.$message.error('已添加！');
            }

        },

        entRemove:function(inx){
            this.idArr2.splice(inx,1);
        },

        userSeek:function(e){
          var vues = this;
          var key = e.replace(/\s+/g,'');
          if(key){
            getEntUser({
               statusList:[1],
               keyword:key,
               sort:2,
               no:1,
               size:12
            }).then(res => {
               vues.selectList3 = res.enterprisePersonList;
               res.enterprisePersonList.forEach((item, i) => {
                   vues.userMap[item.userId] = item;
               });

            })
          }
        },

        userSelect:function(){
            let isSelected = false;
            this.idArr3.forEach((item, i) => {
                if(item.id == this.userId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                let temp = {
                    id:this.userMap[this.userId].userId,
                    name:this.userMap[this.userId].name,
                    enterpriseName:this.userMap[this.userId].enterpriseName,
                }
                this.idArr3.push(temp);
            }else{
                this.$message.error('已添加！');
            }

        },

        userRemove:function(inx){
            this.idArr3.splice(inx,1);
        },

        saveReturn:function(){
            var vues = this;
            // console.log(this.idArr3);
            return new Promise((reslove,reject) => {
                vues.$refs.ruleForm.validate((valid) => {
                    if(valid){
                        var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                        if(vues.radioType == 2){
                            vues.params.visibleRangeType = vues.idArr1.join(',');
                            vues.params.visibleRangeEnterprise = '';
                            vues.params.visibleRangeUser = '';
                        }else if(vues.radioType == 3){
                            let newArr = [];
                            vues.idArr2.forEach((item, i) => {
                                let temp = {
                                    id:item.id,
                                    name:item.name
                                }
                                newArr.push(temp);
                            });
                            vues.params.visibleRangeType = '';
                            vues.params.visibleRangeUser = '';
                            vues.params.visibleRangeEnterprise = JSON.stringify(newArr);
                        }else if(vues.radioType == 4){
                            let newArr = [];
                            vues.idArr3.forEach((item, i) => {
                                let temp = {
                                    id:item.id,
                                    name:item.name,
                                    enterpriseName:item.enterpriseName,
                                }
                                newArr.push(temp);
                            });
                            vues.params.visibleRangeType = '';
                            vues.params.visibleRangeEnterprise = '';
                            vues.params.visibleRangeUser = JSON.stringify(newArr);
                        }


                        reslove(vues.params);
                    }else{
                        reslove(false);
                    }
                })
            })
        }
    },
    mounted:function(){
        var querys = this.$route.query;
        var vues = this;

        dicSeek({code:'sflx'}).then(res => {
            this.selectList1 = res.dataDictionarys;
        })

        if(querys.id){
            decPredat({id:querys.id}).then(res => {

                var unFromate = res.declarationPolicy;
                
                for(var key in vues.params){
                    vues.params[key] = unFromate[key];
                };
                if(vues.params.applicationTimeStart){
                    vues.applicationTime = [vues.params.applicationTimeStart,vues.params.applicationTimeEnd];
                }
                // console.log('vues.applicationTime',vues.applicationTime);
                var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                arrs.forEach((item, i) => {
                    if(vues.params[item]){
                        vues.radioType = i + 2;
                        let tempArr = [];
                        if(i === 0){
                            tempArr = vues.params[item].split(',');
                        }else{
                            tempArr = JSON.parse(vues.params[item]);
                        };
                        vues['idArr' + (i+1)] = tempArr;
                        console.log(vues);
                    }
                });

                vues.$emit('inited');

            }).catch(err => {});
        }

    }
}
</script>

<style lang="scss" scoped>

.selects{
   border-bottom: 1px solid #f5f5f5;
   .select-line{
     position: relative;
     margin-bottom: 20px;
     .selectGp{
       display: inline-block;
       width: 32%;
       span{
         font-size: 15px;
         margin-right: 12px;
       }
     }
   }
}

.text-block{
      font-size: 15px;
      margin-bottom: 20px;
     .bName{
          width: 60px;
          float: left;
          margin-top: 9px;
     }
     .bContent{
          margin-left: 76px;
          position: relative;
     }
}

.title-block{
     width: 32%;
}


.img-block{
   margin-top:30px;
}

.radio-block{
   margin-top: 60px;
}

.tag-block{
   margin-top:45px;
   .bName{
        margin-top: 6px;
   }
}

.check-block{
   margin-top: 30px;
   .check-seek {
       .seek-head{
           position: relative;
           .el-icon-search{
               position: absolute;
               left: 15px;
               top: 12px;
               color: #dcdfe6;
               z-index: 2;
           }
           .el-select{
              width: 432px;
           }
       }
       .seek-body{
            .el-tag{
                margin-right: 12px;
                margin-top: 12px;
            }
       }
   }
}

.enclosure{
   margin-top: 60px;
  .ttl{
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent{
    margin-left: 75px;
  }

}


</style>

<style lang="css">

.subpage.delcare1 .el-input__inner{
  border-radius: 0px !important;
}

.subpage.delcare1 .selects .el-input{
  width: 240px !important;
}

.subpage.delcare1 .el-form-item{
  display: inline-block !important;
  margin-bottom: 0px;
}

.subpage.delcare1 .radio-block .el-radio__label{
    padding-left: 5px !important;
}

.subpage.delcare1 .check-block .el-checkbox__label{
    padding-left: 5px !important;
}

.seek-head .el-input__inner{
    padding-left: 35px !important;
}
</style>



// WEBPACK FOOTER //
// Subpage1.vue?4f57da1e